import { useQuery } from '@tanstack/react-query'
import { buildSubVendorList, type SubVendorListItem } from '../../api/subs'

export function useSubsVendors() {
  return useQuery<SubVendorListItem[]>({
    queryKey: ['subs-vendors'],
    queryFn:  buildSubVendorList,
    staleTime: 60_000,
  })
}
